import { render, staticRenderFns } from "./InfoEnfermeriaItem.vue?vue&type=template&id=327ce03a&scoped=true&"
import script from "./InfoEnfermeriaItem.vue?vue&type=script&lang=js&"
export * from "./InfoEnfermeriaItem.vue?vue&type=script&lang=js&"
import style0 from "./InfoEnfermeriaItem.vue?vue&type=style&index=0&id=327ce03a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ce03a",
  null
  
)

export default component.exports